import { useState } from "react";

import { NotificationExpandToggle } from "./NotificationExpandToggle";
import { Column, Row, Text } from "@/components";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import {
  MIXPANEL_NOTIFICATION_SURFACES,
  MIXPANEL_SCREENS,
} from "@/lib/mixpanel/types";
import { jobPauseTypeToLabel } from "@/lib/constants";
import { getJobLink } from "@/lib/notificationLinks";
import { cn } from "@/lib/utils";
import {
  NotificationPausedJobsReminderPayload,
  NotificationType,
} from "@/types";

export const NotificationPausedJobsList = ({
  isCompact = false,
  payload,
  trackingSurface,
}: {
  isCompact?: boolean;
  payload: NotificationPausedJobsReminderPayload;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { jobs } = payload;

  const render = () => (
    <Column className="gap-0.5">
      <NotificationExpandToggle
        isExpanded={isExpanded}
        notificationType={NotificationType.PAUSED_JOBS_REMINDER}
        setIsExpanded={setIsExpanded}
        trackingSurface={trackingSurface}
      >
        {jobs.length} {jobs.length === 1 ? "job" : "jobs"}
      </NotificationExpandToggle>
      {isExpanded ? (
        <Column className="gap-1 border-l border-slate-200 pl-3 pt-1">
          {jobs.map((job) => (
            <Column
              key={job.jobId}
              className="cursor-pointer gap-0 rounded-md px-2 py-1.5 hover:bg-slate-50"
              onClick={(e) => {
                e.stopPropagation();
                mixpanelUtils.trackRowClick(
                  "Notification list item",
                  MIXPANEL_SCREENS.NOTIFICATIONS,
                  {
                    notification_type: NotificationType.PAUSED_JOBS_REMINDER,
                    surface: trackingSurface,
                  },
                );
                window.open(getJobLink(job), "_blank");
              }}
            >
              <Row className="items-center gap-1.5">
                <Text className={cn("text-sm", isCompact && "text-xs")}>
                  {job.reqTitle}
                </Text>
                <Text className="text-xs font-normal text-slate-500">
                  {jobPauseTypeToLabel[job.pauseType].toLowerCase()}{" "}
                  {job.pausedDays} {job.pausedDays === 1 ? "day" : "days"}
                </Text>
              </Row>
              <Text className="text-xs font-normal text-slate-500">
                {job.customerName}
                {job.pauseReason ? <> &middot; {job.pauseReason}</> : null}
              </Text>
            </Column>
          ))}
        </Column>
      ) : null}
    </Column>
  );

  return render();
};
